import useCallAxios from "./useCallAxios";

export const useInvoices = () => {
  const context = `invoices`;
  const { reset, requestSuccess, requestData, requestError, requestLoading, fetchPOST } =
    useCallAxios({ context });

  const state = requestData?.data;

  const handlePOST = (formData) => {
    fetchPOST({
      body: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      noRefreshData: false,
    });
  };

  return {
    reset,
    loading: requestLoading.POST,
    state,
    success: requestSuccess.POST,
    error: requestError.POST,
    handlePOST,
  };
};

export const useInvoiceValidate = () => {
  const context = `invoicesValidation`;
  const { reset, requestSuccess, requestData, requestLoading, fetchPOST } =
    useCallAxios({ context });

  const handlePOST = (formData) => {
    fetchPOST({
      body: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      noRefreshData: false,
    });
  };

  const state = requestData?.data;

  return {
    reset,
    loading: requestLoading.POST,
    state,
    success: requestSuccess.POST,
    handlePOST,
  };
};

export const useInvoiceDuplicate = () => {
  const context = `invoiceDuplicates`;
  const { reset, requestSuccess, requestData, requestLoading, requestError, fetchPOST } =
    useCallAxios({ context });

  const handlePOST = (body) => {
    fetchPOST({
      body,
      noRefreshData: false,
    });
  };

  const state = requestData?.data;

  return {
    reset,
    loading: requestLoading.POST,
    state,
    success: requestSuccess.POST,
    error: requestError.POST,
    handlePOST,
  };
};